<template>
    <div>
        <pre v-if="false">{{questionario}}</pre>
        <v-row class="pa-1" v-if="!!questionario.id">
            <v-col cols="12" offset-sm="1" sm="10" offset-md="2" md="8" offset-lg="3" lg="6">
                <v-btn-small color="error" @click="deleteQuestionario(questionario)">
                    <v-icon>mdi-delete</v-icon> Remover Questionário
                </v-btn-small>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" offset-sm="1" sm="10" offset-md="2" md="8" offset-lg="3" lg="6">
                <div>
                    <!-- eslint-disable-next-line -->
                    <quill-editor v-model:content="questionario.titulo"
                        :key="questionario.id+'_titulo'"
                        class="quill-questionario-titulos"
                        content-type="html"
                        :toolbar="'minimal'"
                        placeholder="Título do Questionário..."
                    ></quill-editor>
                </div>
                <div>
                    <!-- eslint-disable-next-line -->
                    <quill-editor v-model:content="questionario.subtitulo"
                        :key="questionario.id+'_subtitulo'"
                        class="quill-questionario-titulos"
                        content-type="html"
                        :toolbar="'minimal'"
                        placeholder="Subtítulo do Questionário..."
                    ></quill-editor>
                </div>
                <div>
                    <div v-for="formquest, campo_id in computedQuestoes"
                        :key="campo_id" class="my-1">
                        <v-card variant="outlined" class="ma-0 pa-0" tile>

                            <div class="header-competencia">
                                <v-alert color="#2A3B4D" tile>
                                    <!-- Competencia -->
                                    <v-row>
                                        <v-col class="pa-0" cols="8">
                                            <v-menu transition="slide-y-transition" location="bottom">
                                                <template v-slot:activator="{ props }">
                                                    <v-btn-small variant="plain" block v-bind="props" color="text-white" style="justify-content:left">
                                                        {{campo_id+1}}. {{((formquest||{}).competencia||{}).nome || 'Selecione Competência'}}
                                                    </v-btn-small>
                                                </template>
                                                <v-list density="compact">
                                                    <v-list-item v-for="item in computedCompetencias" :key="item.id"
                                                        @click="formquest.competencia = item">
                                                    <v-list-item-title>{{ item.nome }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>

                                        </v-col>
                                        <v-col class="pa-0" cols="4" align="end">
                                            <!-- Form criação-->
                                            <FormCompetencia
                                                @toggled-form="onToggleFormCompetencia"
                                                :competencia="newCompetencia">
                                                <template v-slot:modal-activate>
                                                <v-btn-small icon title="Criar nova competência">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn-small>
                                                </template>
                                            </FormCompetencia>
                                            <!-- Form alteração-->
                                            <FormCompetencia v-if="!!formquest.competencia && !!formquest.competencia.id"
                                                :competencia="formquest.competencia">
                                                <template v-slot:modal-activate>
                                                <v-btn-small icon :title="'Alterar competência '+formquest.competencia.nome">
                                                    <v-icon>mdi-pencil</v-icon>
                                                </v-btn-small>
                                                </template>
                                            </FormCompetencia>
                                        </v-col>

                                    </v-row>
                                    <span v-if="!!(formquest.competencia||{}).nome">
                                        {{formquest.competencia.descricao}}
                                    </span>

                                    <span v-else>
                                        <v-chip tile label color="error" variant="flat">
                                            Competência não informada
                                        </v-chip>
                                    </span>
                                </v-alert>
                            </div>

                            <span class="">
                                <!-- eslint-disable-next-line -->
                                <quill-editor v-model:content="formquest.titulo"
                                    :key="campo_id+'_questao'"
                                    class="quill-questionario-questoes"
                                    content-type="html"
                                    placeholder="Texto da questão aqui..."
                                    toolbar="minimal">
                                </quill-editor>
                            </span>

                            <div class="questao-actions">
                                <v-row class="px-1">
                                    <!-- Botões de Ordem de questões -->
                                    <v-btn-small icon title="Mover para cima" @click="formquest.ordem--" :disabled="formquest.ordem<=0"><v-icon>mdi-minus</v-icon></v-btn-small>
                                    <v-chip tile color="#ddd" variant="flat" class="pa-5">
                                        Ordem Questão {{formquest.ordem}}
                                    </v-chip>
                                    <v-btn-small icon title="Mover para baixo" @click="formquest.ordem++" :disabled="formquest.ordem==computedQuestoes.length"><v-icon>mdi-plus</v-icon></v-btn-small>
                                    <v-spacer></v-spacer>
                                    <v-menu transition="slide-y-transition" location="start">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-small v-bind="props" icon="mdi-cog"></v-btn-small>
                                        </template>
                                        <v-list density="compact">
                                            <v-list-item
                                                v-for="(item, index) in [
                                                    { show: formquest.tipo !== 'text', title: 'Tipo Subjetiva', action: () => alterarTipoFormText(formquest) },
                                                    { show: formquest.tipo !== 'single', title: 'Tipo Objetiva', action: () => alterarTipoFormSingle(formquest) },
                                                    { show: true, title: 'Copiar', action: () => copyOptions(formquest) },
                                                    // eslint-disable-next-line
                                                    { show: true, title: 'Remover Questão', action: () => questionario.questoes.splice(campo_id, 1)},
                                                    { show: !(formquest.subquestions || []).length > 0, title: 'Adicionar 5W2H', action: () => generate5W2HSubquestions(formquest)},
                                                    { show: (formquest.subquestions || []).length > 0, title: 'Remover 5W2H', action: () => remove5W2H(formquest)},
                                                    { show: formquest.tipo !== 'text', title: 'Adicionar Opção', action: () => adicionaOpcao(formquest)},
                                                ]"
                                                :key="index"
                                                @click="item.action"
                                                v-show="item.show"
                                            >
                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-row>
                                <v-divider class="my-1"></v-divider>
                            </div>
                            <!-- Quando o tipo for single, a opção será um unica escolha (radio) -->
                            <div class="questao-options">
                                <div v-if="(formquest.subquestions || [] ).length">
                                    <h3 class="ml-2">5W2H</h3>
                                    <div v-for="(subquest, index) in formquest.subquestions" :key="index">
                                        <li class="ml-3" v-text="subquest.titulo"></li>
                                        <!-- <v-text-field v-model="subquest.resposta" :label="subquest.titulo" hide-details></v-text-field> -->
                                    </div>
                                </div>
                                <div v-if="formquest.tipo === 'text'"
                                    class="text-center text-disabled py-6">
                                    <i class="font-italic">Resposta a redigir</i>
                                </div>
                                <div v-if="formquest.tipo === 'single'">
                                    <div v-for="campo, ind in formquest.options||[]" :key="ind"
                                        :title="'peso: '+campo.peso"
                                        class="px-1 py-3">
                                        <v-row>
                                            <v-text-field v-model="campo.label"
                                                placeholder="Legenda da Opção"
                                                style="width:200px"
                                                hide-details
                                                >
                                                <template v-slot:prepend-inner>
                                                    <v-icon>mdi-radiobox-blank</v-icon>
                                                </template>
                                                <template v-slot:prepend>
                                                    <v-icon-small title="Remover Opção" class="ml-2"
                                                        @click="()=>formquest.options.splice(ind, 1)">mdi-delete</v-icon-small>
                                                </template>
                                            </v-text-field>
                                            <v-spacer></v-spacer>
                                            <v-text-field v-model="campo.peso"
                                                v-show="formquest.tipo !== 'text'"
                                                label="Peso"
                                                type="number"
                                                style="width:100px;"
                                                hide-details
                                            ></v-text-field>
                                        </v-row>
                                    </div>
                                </div>
                            </div>
                            <v-divider class="my-2"></v-divider>
                            <div class="questao-obrigatoria">
                                <v-checkbox v-model="formquest.obrigatoria"
                                    :true-value="false"
                                    :false-value="true"
                                    label="Questão Opcional"
                                    ></v-checkbox>
                            </div>
                        </v-card>
                        <!-- Exibir somente para CIT o JSON -->
                        <pre v-if="$verify.is_superuser() && false">{{formquest}}</pre>
                    </div>
                    <!-- </v-alert> -->
                    <!-- Botão para salvar o questionario -->
                    <div>
                        <v-btn v-show="computedQuestoes.length > 0"
                            @click="saveQuestionario">Salvar Questionário</v-btn>
                    </div>
                    <!-- PREVIEW FORMULARIO PARA SUPERUSER -->
                    <v-card color="black" dark tile v-show="$verify.is_superuser() && false">
                        <v-card-title>
                            Formulário:
                        </v-card-title>
                        <v-card-text class="text-success">
                            <pre>{{computedQuestoes}}</pre>
                        </v-card-text>
                    </v-card>
                </div>
            </v-col>
            <v-col cols="12" offset-sm="1" sm="10" offset-md="2" md="8" offset-lg="3" lg="6">
                <v-alert tile colored-border color="primary" elevation="0">
                    <v-row class="py-2">
                        <!-- Tipo de Questão -->
                        <v-select :items="[
                                    { value: 'text', title: 'Subjetiva' },
                                    { value: 'single', title: 'Objetiva' },
                                    ]"
                            label="Tipo de Questão"
                            messages="Respostas objetivas ou subjetivas"
                            v-model="novoCampo.tipo"
                            >
                        </v-select>
                        <v-btn-small icon color="success" 
                            @click="adicionaQuestao({
                                ...novoCampo,
                                ordem: computedQuestoes.length+1,
                                value: null //deve estar null ao criar/atualizar questionario
                            })">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn-small>
                    </v-row>
                </v-alert>
            </v-col>
        </v-row>
        <div ref="scrollToMe"></div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import FormCompetencia from '@/components/rh/competencias/Form.vue';
export default {
    components: {
        FormCompetencia
    },
    props:{
        id: {
            type: String,
            required:false
        },
        object: {
            type: Object,
            required: false
        },
        questionarioteste: {
            type: Object,
            required:false,
        }
    },
    data(){
        return {
            competencias:[],
            newCompetencia: {
                nome: null,
                descricao: null
            },
            novoCampo: {
                competencia: null,
                ordem: 0,
                titulo: null,
                label: '',
                peso: 0,
                tipo: 'single',
                options: [],
                value: null,
                obrigatoria: true,
                subquestions: []
            },
            templateModelNovoCampo: {
                competencia: null,
                ordem: 0,
                titulo: null,
                label: '',
                peso: 0,
                tipo: 'single',
                options: [],
                value: null,
                obrigatoria: true,
                subquestions: []
            },
            questionario: {
                titulo:'#Título do Questionário',
                subtitulo:'',
                questoes: []
            },
            questionario_model: {
                titulo:'',
                subtitulo:'',
                questoes: [],
            }
        }
    },
    methods: {

        remove5W2H(formquest) {
            if (formquest && (formquest.subquestions || []).length > 0) {
                formquest.subquestions = [];
            }
        },

        async deleteQuestionario(q){
            const conf = confirm('Tem certeza que deseja remover este Questionário?')
            if (!conf) return
            const deleted = await this.$store.dispatch('DeleteRHQuestionario', q)
            if (deleted){
                this.$emit('on-delete-form', true)
            }
        },
        scrollDown() {
            const el = this.$refs.scrollToMe;
            if (el) {
                el.scrollIntoView({behavior: 'smooth'});
            }
        },
        onToggleFormCompetencia(value){
        if(!value){
            // limpar competencia do FormCompetencia ao fechar a modal
            this.newCompetencia = Object.assign({ nome: null, descricao: null })
        }
        },
        ...mapActions(['CreateQuestionario']),
        adicionaQuestao(nova_questao){
            if (nova_questao.tipo === '5W2H') {
                nova_questao.subquestions = this.generate5W2HSubquestions();
            }

            if ((nova_questao.options||[]).length == 0){
                nova_questao.options = [
                    {
                        label: nova_questao.tipo !== 'text' ? 'Texto da opção': '',
                        peso: 0,
                        ordem: 0
                    }]
            }
            // return alert('Nenhuma Opção foi adicionada à questão')
            // Adiciona questão ao formulário
            try{
                this.questionario.questoes.push(nova_questao)
            } catch {
                this.questionario.questoes = []
                this.questionario.questoes.push(nova_questao)
            }
            this.novaQuestao()
        },
        generate5W2HSubquestions(formquest) {
            const novaQuestao5W2H = [
                { id: 'what', titulo: 'O que (o que é a meta?)', resposta: '' },
                { id: 'why', titulo: 'Por que (Por que ela é importante?)', resposta: '' },
                { id: 'who', titulo: 'Quem (Quem será responsável por esta entrega?)', resposta: '' },
                { id: 'where', titulo: 'Onde (Onde será realizada?)', resposta: '' },
                { id: 'when', titulo: 'Quando (Qual prazo para entrega?)', resposta: '' },
                { id: 'how', titulo: 'Como (De que forma a entrega será feita, quais as ações?)', resposta: '' },
                { id: 'how much', titulo: 'Quanto (Orçamento, caso necessário)', resposta: '' },
            ]

            formquest.subquestions = novaQuestao5W2H
        },
        novaQuestao(){
            // Limpar o novo Campo para criar nova Questão
            const model = this.templateModelNovoCampo
            this.novoCampo = Object.assign({}, model)
            // Focar o campo para digitação
            setTimeout( () => { this.scrollDown() }, 100)
            //   this.$refs.novoCampoText.focus()
        },
        copyOptions(questao){
            // this.novaQuestao()
            // this.novoCampo.options = Object.assign([], options)
            const q = Object.assign({}, questao)
            q['competencia'] = {};
            q['titulo'] = null;
            // eslint-disable-next-line
            this.questionario.questoes.push(q)

        },
        alterarTipoFormText(formquest){
            if(formquest.tipo == 'single'){
                formquest.tipo = 'text';
                formquest.options = Object.assign([], [{
                    label: '', peso: 0, ordem: 0
                }])
            }
        },
        alterarTipoFormSingle(formquest){
            if(formquest.tipo == 'text'){
                formquest.tipo = 'single';
                formquest.options = Object.assign([], [{
                    label: '', peso: 0, ordem: 0
                }])
            }
        },
        adicionaOpcao(formquest){
            if(formquest.tipo == 'single'){
                // Replicar a última Opção
                const copyLastOption = Object.assign({},formquest.options[(formquest.options||[]).length-1])
                copyLastOption.peso = parseInt(copyLastOption.peso||0) + 1
                copyLastOption.label = `Opção ${(formquest.options||[]).length+1}`
                formquest.options.push(Object.assign({}, copyLastOption))
            }
        },
        validaForm(){
            if (!this.questionario.titulo){
                alert('Questionário sem título informado!')
                return false
            }
            if (this.questionario.questoes.filter(questao => questao.obrigatoria).length === 0 ){
                alert('Não existem questões obrigatórias no questionário!');
                return false;
            }
            // if (!this.questionario.subtitulo){
            //     alert('Questionário sem subtítulo informado!')
            //     return false
            // }
            if (this.questionario.questoes.filter(i => i.competencia == null).length > 0 ){
                alert('Existe questão sem competência informada!')
                return false
            }
            return true
        },
        async saveQuestionario(){
            if(!this.validaForm()) return
            if(this.questionario && this.questionario.id){
                const updated = await this.$store.dispatch('UpdateRHQuestionario', this.questionario)
                if (updated) {
                    this.$emit('on-update-form', true)
                }
            } else {
                const created = await this.$store.dispatch('CreateRHQuestionario', this.questionario)
                if (created) {
                    this.$emit('on-create-form', true)
                    this.resetForm()
                }
            }
        },
        resetForm(){
            // eslint-disable-next-line
            this.questionario = Object.assign({}, this.questionario_model)
        },
        async get_competencias(){
            await this.$store.dispatch('GetRHCompetencias')
        },
        init(){
            this.get_competencias()
            if(!!this.object && !!this.object.id){
                this.questionario = Object.assign({}, this.object)
            }
        }
    },
    computed:{
        computedQuestoes(){
            const sort_by_ordem = (a,b) => a.ordem-b.ordem
            const q = this.questionario.questoes||[]
            return q.sort(sort_by_ordem)
        },
        computedCompetencias(){
            const q = (this.$store.state.rh.competencias||[]).map(o => ({
                                                                id: o.id,
                                                                nome: o.nome,
                                                                descricao: o.descricao
                                                            }))
            return q
        }
    },
    mounted(){
        this.init()
    },
}
</script>
<style scoped>
.links{
    text-decoration: none;
}
</style>